import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Type } from 'projects/c1-backend/src/app/db/type';
import { AddressesService } from 'projects/c1-backend/src/app/services/addresses.service';
import { TypesService } from 'projects/c1-backend/src/app/services/types.service';
import { AddressDetailsComponent } from 'projects/c1-backend/src/app/views/address/address-details/address-details.component';
import { AddressComponent } from 'projects/c1-backend/src/app/views/address/address.component';
import { Globals } from 'projects/core/src/globals';
import { Model } from 'projects/core/src/include/model';
import { User } from 'projects/core/src/include/structures';
import { UsersComponent } from 'projects/core/src/settings/users/users.component';
import { Dossier, DossierField, DossierPhase } from '../../../dossier';
import { DossierService } from '../../../services/dossier.service';
import { UserService } from 'projects/core/src/lib/user.service';

@Component({
  selector: 'app-detailphase',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css']
})
export class DetailComponent extends Model<Dossier> implements OnInit,AfterViewInit {
  tab=0;
  tab_phase=-1;

  @ViewChild('modalSelectTypes')
  modalSelectTypes:TemplateRef<any>;
  modalSelectTypesRef:NgbModalRef;

  @ViewChild('modalNote')
  modalNote:TemplateRef<any>;
  modalNoteRef:NgbModalRef;
  log_note:string="";
  log_id_phase:number;
  log_state:number;

  types:Type[]=[];
  id_section=0;

  

  get user(){
    return Globals.user;
  }

  users:any=[];
  
  constructor(
    private route1: ActivatedRoute,
    private dossierService: DossierService,
    private addressesService:AddressesService,
    private typesService:TypesService,
    private modalService:NgbModal,
    private usersService:UserService
  ) { 
    super(route1,dossierService);
  }
  modulename="dossier";

  ngOnInit(): void {

    this.title = 'Dettaglio Pratica';
    super.ngOnInit.apply(this, arguments); 
    this.record=new Dossier();

    if (this.checkPermission('showOnlyDataSection')) {
      this.tab = 5;
    }

    this.usersService.getUsers().subscribe((items)=>{
      this.users=items;
    });

    this.typesService.getTypes("dossier").subscribe((items)=>{
      this.types=items;
    });

  
    this.afterGetItem=()=>{
      if(this.record.id==0){ //se è un nuovo record apri il wizard
       
        if(this.types.length>1){ //se ci sono più tipologie apri la modale per selezionare la tipologia
          this.openSelectTypes();
        }else{
          this.record.id_type=this.types.length>0?this.types[0].id:0;
          this.selectAddress();
          this.record.id_current_phase==1;
          this.save();
        }
      }else{
        if(this.record.title) {
          this.title=this.record.code+" ("+this.record.title+")";
        }else{
          this.title=this.record.code
        }

        try{
          this.record['errors']=JSON.parse(this.record.errors);
        }catch{
          this.record['errors']=[];
        }

        this.dossierService.setDossierRead(this.record.id).subscribe((res)=>{});


      }
    }
    

    this.beforeSave=(callback:any)=>{
      this.dossierService.checkDuplicate(this.record.id,this.record.code).subscribe((res)=>{
        if(res){
          Globals.modal.showConfirm("Codice già presente","Lo stesso codice è stato inserito in un altra pratica. Continuare il salvataggio?",()=>{
            if(callback) callback(true);
          },"Continua","Annulla","warning")
        }else{
          if(callback) callback(true);
        }
      })
    }
  }


  ngAfterViewInit(): void {
    this.getItem();
  }


  checkPermission(permissionname: String){
    return Globals.permissions.checkPermission('dossier',permissionname);
  }


  selectAddress(){
    Globals.modal.showModal(AddressComponent,[{"name":"mode","value":"modal"},{"name":"title","value":"Seleziona un'anagrafica"}],(instance)=>{
      let r=instance['recordSelected'];

      this.OnSelectAddress(r);

    });
  }

  OnSelectAddress(r){
    if(r){
      this.record.addressItem=r;
      this.record.id_address=r.id;
      
      if(this.module.getParam("user_assignment")=="currentuser"){
        this.record.id_user=Globals.user.id;
        this.record.username=Globals.user.name;
      }else{
        this.record.id_user=this.record.addressItem.id_user;
        this.record.username=this.record.addressItem.username;
      }

     
    }
  };

  OnViewAddress(r){
    Globals.modal.showModal(AddressDetailsComponent,[
      {"name":"mode","value":"modal"},
      {"name":"id","value":r.id}
    ],(instance)=>{
      if(instance!=null)
        this.OnSelectAddress(instance['record']);
    });
  }


  searchUser(){
    
    Globals.modal.showModal(UsersComponent,[
      {"name":"mode","value":"modal"},
    ],(instance)=>{
      if(instance){
        
        let user:User=instance['recordSelected'];
        this.linkUser(user);        

      }
    });
  }


  linkUser(user:User){    

   this.record.id_user=user.id;
   this.record.username=user.name;    

  }


  unlinkUser(){
    Globals.modal.showConfirm("","Confermi di voler scollegare l'utente dalla pratica?",()=>{        
      this.record.id_user=0;
      this.record.username="";
    },"Sì, scollega","No. Annulla","warning");
  }


  openSelectTypes(){
    this.modalSelectTypesRef=this.modalService.open(this.modalSelectTypes);

  }

  onSelectType(id_type){
    this.record.id_type=id_type;
    this.modalSelectTypesRef.close("success");
    this.selectAddress();
  }


  getPhaseStatus(id_phase,phase){
    //esplora i log e trova l'ultimo stato di una fase
    let state=0;
    if(this.record.log && this.record.log.length>0){
     
      for(let l of this.record.log){
        if(l['id_phase']==id_phase){
          state=l['state'];
          if(phase)
            phase['state']=state;
        }
      }
    }
   
    return state;


  }

  setPhase(id_phase,state){
    this.dossierService.setPhase(this.record.id,id_phase,state,this.log_note).subscribe((items)=>{
      if(state==4){
        //se la fase è su "Verificata" imposta la procedura sulla fase successiva
        let nextPhase:DossierPhase;
        for(let i=0;i<this.record.phases.length;i++){
          if(this.record.phases[i].id==this.record.id_current_phase){
            if(i<this.record.phases.length-1){
              this.record.id_current_phase=this.record.phases[i+1].id;
              nextPhase=this.record.phases[i+1];
              break;
            }else{
              this.record.state=2;
            }
          }
        }

        // Chiedi se la fase successiva deve essere messa in corso
        Globals.modal.showConfirm("Cambio fase","Imposto la fase successiva su in corso?",()=>{        
          this.dossierService.setPhase(this.record.id,this.record.id_current_phase,1,this.log_note).subscribe((items)=>{
            this.dossierService.getLog(this.record.id).subscribe((logs)=>{
              this.record.log=logs;
            });
          });      
        },"Sì","No, annulla");
        // if(confirm("Impostare la fase "+nextPhase.title+" in 'in corso'?")){
        //   this.dossierService.setPhase(this.record.id,this.record.id_current_phase,1,this.log_note).subscribe((items)=>{
        //     this.dossierService.getLog(this.record.id).subscribe((logs)=>{
        //       this.record.log=logs;
        //     });
        //   });
        // }

      }
      
      this.dossierService.getLog(this.record.id).subscribe((logs)=>{
        
        this.record.log=logs;
      });
    });
  }


  getFirstIdSection(id_phase){
    let sections=this.getSections(id_phase);
    if(sections.length>0){
      return sections[0].id;
    }
    return 0;
  }


  expandPhase(id,tab,i) {
    this.id_section=this.getFirstIdSection(id);
    tab==i?this.tab_phase=-1:this.tab_phase=i;
  }
  


  countSections(fields){
    var c=0;
    for(let s of fields){
      if(s.type=="section") c++;
    }
    return c;
  }

  moveNextSection(id_section,fields,test){
    var sections=[];
    for(let s of fields){
      if(s.type=="section") sections.push(s);
    }

    for(let i=0;i<sections.length;i++){
      if(sections[i].id==id_section){
        if(i<sections.length-1){
          if(!test) {
            this.id_section=sections[i+1].id;
            return;
          } else {
            return true; // Verifica se è possibile passare al successivo
          }
        }
      }
    }
  }

  movePrevSection(id_section,fields,test:boolean=false){
    var sections=[];
    for(let s of fields){
      if(s.type=="section") sections.push(s);
    }

    for(let i=0;i<sections.length;i++){
      if(sections[i].id==id_section){
        if(i>0){
          if(!test) {
            this.id_section=sections[i-1].id;
            return;
          } else {
            return true; // Verifica se è possibile passare al precedente
          }
        }
      }
    }
  }
  

  getSections(id_phase){
    for(let p of this.record.phases){
      if(p.id==id_phase)
        return p.sections==null?[]:p.sections;
    }
  }

  updateLog(log){
    this.dossierService.updateLog(log,()=>{
      log['editNote']=false;
    });
  }

  openModalNote(id_phase,state){
    this.log_id_phase=id_phase;
    this.log_state=state;
    this.modalNoteRef=this.modalService.open(this.modalNote);
  }
  confirmModalNote(){
    this.modalNoteRef.close("success");
    this.setPhase(this.log_id_phase,this.log_state);
  }
  closeModalNote(){
    this.modalNoteRef.close("success");
  }

  checkEnableCondition(fields,enable_condition_fieldname,defaultvalue=null,access){
    
    //if(access==0) return false; //TODO da controllare

    if(enable_condition_fieldname){
      for(let f of fields){
        if(f.name==enable_condition_fieldname){

          if(defaultvalue==null || defaultvalue==""){
            if(f.value=='' || f.value==0 || f.value==undefined || f.value==null){
              return false;
            }
          }else{
            const v=defaultvalue.split(";");
            if(v.indexOf(f.value)==-1)
              return false
          }
    
        }
      }
    }

    return true;
  }


  /** Conta quanti (obbligatori) sono compilati per sezione */
  getCompiledField(id_phase,id_section=0){
    let count=0;
    let sections=this.getSections(id_phase);
    for(let s of sections){
      if(s.id==id_section || id_section==0){
        for(let f of s.fields){
          if(f.value=="" && f.required){
            count++;
          }
        }
      }
    }

    return count;
  }

  deleteAlarm(e:Dossier){
    for(let i=0;i<this.record.errors.length;i++){
      if(this.record.errors[i]==e){
        this.record.errors.splice(i,1);
        return;
      }
    }
  }

  addUser(){
    this.record.users.push({
      "id":0,
      "id_user":0,
      "permissions":"",
      "show":true
    })
  }

  deleteUser(u:any){
    for(let i=0;i<this.record.users.length;i++){
      if(this.record.users[i]==u){
        this.record.users.splice(i,1);
        return;
      }
    }
  }

  checkFieldUserPermission(field:DossierField){
    //se sei un superuser o admin puoi sempre visualizzare il campo
    if(this.user.isSuperUser() || this.user.isAdmin()) return true;
    
    //se il campo è pubblico o pubblico (sola visione) può essere visualizzato
    if(field.access==1 || field.access==3) return true;

    //se il campo è privato ma hai il permesso puoi visualizzarlo
    if(field.access==2 && !this.checkPermission('showOnlyDataSection')) return true;

    return false;
  }

  checkFieldUserDisabled(field:DossierField){
    //se sei un superuser o admin puoi sempre modificare il campo
    if(this.user.isSuperUser() || this.user.isAdmin()) return false;

    //se il campo è pubblico può essere modificato da tutti
    if(field.access==1) return false;

     //anche se il campo è privato o pubblico (sola visione) ma hai il permesso, puoi modificarlo
    if((field.access==2 || field.access==3) && !this.checkPermission('showOnlyDataSection')) return false;

    return true;
  }
  
}